import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const Payroll3DIcon = (t0)=>{
    const $ = c(7);
    const { width, height, color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter0_i_3982_59688)",
            children: /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M40.7992 23.9871V31.1976L40.799 31.2421C40.7571 36.5236 33.2516 40.7976 23.9992 40.7976C14.7208 40.7976 7.20114 36.4995 7.20114 31.1976L7.20019 24.088C7.19954 24.0532 7.19922 24.0184 7.19922 23.9835L7.19922 16.8027C7.19922 16.8018 7.19922 16.8009 7.19922 16.8C7.20143 11.4991 14.7222 7.19995 23.9992 7.19995C33.2475 7.19995 40.7506 11.4702 40.7992 16.7484V23.9835C40.7992 23.9847 40.7992 23.9859 40.7992 23.9871ZM37.1992 23.9835L37.1992 22.7391C34.1228 24.9686 29.3535 26.4 23.9992 26.4C18.6456 26.4 13.8769 24.969 10.8005 22.74L10.8006 24.0506C10.8335 24.8632 11.4689 26.2535 13.9059 27.6461C16.3096 29.0196 19.8705 29.9835 23.9992 29.9835C28.128 29.9835 31.6889 29.0196 34.0925 27.6461C36.5945 26.2164 37.1976 24.789 37.1992 23.9869C37.1992 23.9858 37.1992 23.9847 37.1992 23.9835ZM10.8 16.8517C10.8255 17.6621 11.4535 19.0611 13.9059 20.4625C16.3096 21.836 19.8705 22.8 23.9992 22.8C28.128 22.8 31.6889 21.836 34.0925 20.4625C36.594 19.0331 37.1973 17.6061 37.1992 16.8038C37.1992 16.8025 37.1992 16.8012 37.1992 16.8C37.198 15.998 36.5956 14.5677 34.0925 13.1374C31.6889 11.7639 28.128 10.8 23.9992 10.8C19.8704 10.8 16.3096 11.7639 13.9059 13.1374C11.4533 14.5389 10.8254 15.9381 10.8 16.7484L10.8 16.8517ZM10.8011 31.2421L10.801 29.924C13.8775 32.1528 18.646 33.5835 23.9992 33.5835C29.3535 33.5835 34.1228 32.1522 37.1992 29.9227V31.1976C37.1992 31.9992 36.598 33.4285 34.0925 34.8602C31.6889 36.2337 28.128 37.1976 23.9992 37.1976C19.8704 37.1976 16.3096 36.2337 13.9059 34.8602C11.4462 33.4546 10.8231 32.0514 10.8011 31.2421Z",
                fill: color
            })
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("defs", {
            children: /*#__PURE__*/ jsxs("filter", {
                id: "filter0_i_3982_59688",
                x: "6.19922",
                y: "7.19995",
                width: "34.5996",
                height: "34.5977",
                filterUnits: "userSpaceOnUse",
                colorInterpolationFilters: "sRGB",
                children: [
                    /*#__PURE__*/ jsx("feFlood", {
                        floodOpacity: "0",
                        result: "BackgroundImageFix"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in: "SourceGraphic",
                        in2: "BackgroundImageFix",
                        result: "shape"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        in: "SourceAlpha",
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                        result: "hardAlpha"
                    }),
                    /*#__PURE__*/ jsx("feOffset", {
                        dx: "-1",
                        dy: "1"
                    }),
                    /*#__PURE__*/ jsx("feGaussianBlur", {
                        stdDeviation: "0.5"
                    }),
                    /*#__PURE__*/ jsx("feComposite", {
                        in2: "hardAlpha",
                        operator: "arithmetic",
                        k2: "-1",
                        k3: "1"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        type: "matrix",
                        values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in2: "shape",
                        result: "effect1_innerShadow_3982_59688"
                    })
                ]
            })
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== height || $[4] !== t1 || $[5] !== width) {
        t3 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2
            ]
        });
        $[3] = height;
        $[4] = t1;
        $[5] = width;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
export { Payroll3DIcon };
